import { render, staticRenderFns } from "./Customized.vue?vue&type=template&id=3c9ade5e&scoped=true&"
import script from "./Customized.vue?vue&type=script&lang=js&"
export * from "./Customized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ade5e",
  null
  
)

export default component.exports